import React from "react";
import { useIntl } from "react-intl";
import { ErrorModal } from "@folio/stripes/components";
/** The heading of every failed-action modal in the module (CZNA-1626). */
export var ACTION_ERROR_HEADING_ID = "ui-czna-users.error.modal.heading";
/**
 * The module's one error modal for a failed action.
 *
 * CZNA-1626: the heading is a neutral "Akce se nezdařila" and the advice lives in the body
 * only. The heading used to be error.generic ("Došlo k chybě. Zkuste to prosím znovu."), so a
 * 403 modal told the administrator to try again above a body saying the permission is
 * missing. Use this instead of stripes' ErrorModal (ActionErrorModal.test.tsx holds that).
 */
var ActionErrorModal = function (_a) {
    var open = _a.open, message = _a.message, onClose = _a.onClose;
    var intl = useIntl();
    return (React.createElement(ErrorModal, { open: open, label: intl.formatMessage({ id: ACTION_ERROR_HEADING_ID }), content: message, onClose: onClose }));
};
export default ActionErrorModal;
